<template>
  <label
    class="input-email"
    v-bind:class="tags">
    <span class="input-email__label">{{ label }}</span>
    <input
      class="input-email__input"
      data-lpignore="true"
      type="email"
      v-bind:class="inputClasses"
      v-bind:placeholder="placeholder"
      v-bind:required="required"
      v-bind:value="value"
      v-on:input="onInput" />
    <p
      class="input-email__violation"
      role="alert"
      v-for="text in violations"
      v-bind:key="text"
    >{{ text }}</p>
  </label>
</template>
<script>
export default {
  computed: {
    tags() {
      const list = [];
      if (this.violations.length > 0) {
        list.push('invalid');
      }
      return list;
    },
  },
  methods: {
    /**
     * @description Обработать ввод значения.
     * @param {InputEvent} event
     * @returns {void}
     */
    onInput(event) {
      const { value } = event.target;
      this.$emit('input', value);
    },
  },
  name: 'InputEmail',
  props: {
    placeholder: { default: () => '', type: String },
    required: { default: () => true, type: Boolean },
    /**
     * @description Классы элемента ввода.
     * @type {Object.<string,boolean>}
     */
    inputClasses: {
      default: () => ({}),
      required: false,
      type: Object,
    },
    /**
     * @description Заголовок.
     * @type {string}
     */
    label: {
      required: true,
      type: String,
    },
    /**
     * @description Значение.
     * @type {string}
     */
    value: {
      default: () => '',
      required: false,
      type: String,
    },
    /**
     * @description Список нарушений.
     * @type {string[]}
     */
    violations: {
      default: () => [],
      required: false,
      type: Array,
    },
  },
};
</script>
<style lang="scss" scoped>
@use "@/scss/buttons";
@use "@/scss/fields";
.input-email {
  display: flex;
  flex-direction: column;
  &__label {
    color: var(--unfocus-color);
    font-size: .75rem;
    font-weight: 400;
    line-height: 1rem;
    margin: 0 0 2px 0;
  }
  &__input {
    @include fields.input-field();
  }
  &.invalid &__input {
    color: var(--warning-color);
  }
  &__violation {
    color: var(--warning-color);
    font-size: .75rem;
    line-height: 14px;
    font-weight: 400;
    padding: .125rem;
  }
}
</style>
